import { httpClient } from '../httpClient/httpClient';

export interface ArticleTag {
  id: number;
  name: string;
}

export interface ArticleTagRequest {
  name: string;
}

export const articleTagsApi = {
  getAll: (organizationId: number) =>
    httpClient.get<ArticleTag[]>(`organizations/${organizationId}/articletags`),
  create: (organizationId: number, request: ArticleTagRequest) =>
    httpClient.post<ArticleTag>(`organizations/${organizationId}/articletags`, {
      data: request,
    }),
  update: (id: number, request: ArticleTagRequest) =>
    httpClient.put<ArticleTag>(`articletags/${id}`, { data: request }),
  delete: (id: number) => httpClient.delete(`articletags/${id}`),
};
